export function isMobileView() {
  if (navigator.userAgent.match(/Android/i)||
        navigator.userAgent.match(/webOS/i)||
        navigator.userAgent.match(/iphone/i)){
    return true
  } else {
    return false
  }
}
